import React, { useState, Fragment } from 'react';
import { Card } from '../../components/ui/Card';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Search, ChevronDown, ChevronRight, Star, Check, Clock, MessageSquare } from 'lucide-react';
const ORDER_TABS = [{
  label: 'Live Queue',
  path: ''
}, {
  label: 'Flagged (3)',
  path: 'flagged'
}, {
  label: 'Order History',
  path: 'history'
}, {
  label: 'Analytics',
  path: 'analytics'
}];
const HISTORY_DATA = [{
  id: '#4521',
  time: '14:32',
  location: 'Vračar',
  channel: 'Wolt',
  items: 3,
  total: '1,890',
  prep: '8:20',
  rating: '9.5',
  status: 'Done'
}, {
  id: '#4520',
  time: '14:28',
  location: 'Vračar',
  channel: 'Wolt',
  items: 2,
  total: '1,450',
  prep: '12:45',
  rating: '8.0',
  status: 'Done',
  warning: true,
  expanded: true,
  details: {
    items: [{
      name: '1x Triple Smash',
      price: '890 RSD'
    }, {
      name: '2x Pepsi',
      price: '560 RSD'
    }],
    timeline: [{
      time: '14:28',
      status: 'New'
    }, {
      time: '14:30',
      status: 'In Progress'
    }, {
      time: '14:41',
      status: 'Ready'
    }, {
      time: '14:48',
      status: 'Picked Up'
    }],
    stations: '🍔 Burgeri',
    est: '10 min',
    actual: '12:45',
    diff: '+2:45',
    comment: 'Food was cold'
  }
}, {
  id: '#4519',
  time: '14:25',
  location: 'Vračar',
  channel: 'Collina',
  items: 4,
  total: '2,100',
  prep: '7:15',
  rating: '10',
  status: 'Done'
}, {
  id: '#4518',
  time: '14:20',
  location: 'BB',
  channel: 'Wolt',
  items: 2,
  total: '1,200',
  prep: '9:30',
  rating: '9.0',
  status: 'Done'
}, {
  id: '#4517',
  time: '14:15',
  location: 'Vračar',
  channel: 'Wolt',
  items: 5,
  total: '3,200',
  prep: '6:50',
  rating: '10',
  status: 'Done'
}];
export function OrderHistory() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-2693">
      <h1 className="text-2xl font-bold text-text-primary" data-id="element-2694">Order History</h1>
      <TabNavigation tabs={ORDER_TABS} basePath="/orders" data-id="element-2695" />

      {/* Filters */}
      <Card className="p-4 flex flex-wrap gap-4 items-center" data-id="element-2696">
        <span className="text-sm font-bold text-text-secondary uppercase tracking-wider mr-2" data-id="element-2697">
          Filters:
        </span>
        <button className="flex items-center gap-2 px-3 py-1.5 bg-background border border-white/10 rounded-lg text-sm hover:bg-white/5" data-id="element-2698">
          All Locations <ChevronDown size={14} data-id="element-2699" />
        </button>
        <button className="flex items-center gap-2 px-3 py-1.5 bg-background border border-white/10 rounded-lg text-sm hover:bg-white/5" data-id="element-2700">
          All Channels <ChevronDown size={14} data-id="element-2701" />
        </button>
        <button className="flex items-center gap-2 px-3 py-1.5 bg-background border border-white/10 rounded-lg text-sm hover:bg-white/5" data-id="element-2702">
          Today <ChevronDown size={14} data-id="element-2703" />
        </button>
        <div className="flex-1" data-id="element-2704"></div>
        <div className="relative" data-id="element-2705">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary" data-id="element-2706" />
          <input type="text" placeholder="Search #, customer" className="bg-background border border-white/10 rounded-lg pl-9 pr-4 py-1.5 text-sm focus:outline-none focus:border-accent-primary w-64" data-id="element-2707" />
        </div>
      </Card>

      {/* Table */}
      <Card noPadding data-id="element-2708">
        <div className="overflow-x-auto" data-id="element-2709">
          <table className="w-full text-sm" data-id="element-2710">
            <thead data-id="element-2711">
              <tr className="text-text-secondary border-b border-white/5" data-id="element-2712">
                <th className="w-8 p-4" data-id="element-2713"></th>
                <th className="text-left p-4 font-medium" data-id="element-2714">ORDER</th>
                <th className="text-left p-4 font-medium" data-id="element-2715">TIME</th>
                <th className="text-left p-4 font-medium" data-id="element-2716">LOCATION</th>
                <th className="text-left p-4 font-medium" data-id="element-2717">CHANNEL</th>
                <th className="text-center p-4 font-medium" data-id="element-2718">ITEMS</th>
                <th className="text-right p-4 font-medium" data-id="element-2719">TOTAL</th>
                <th className="text-center p-4 font-medium" data-id="element-2720">PREP</th>
                <th className="text-center p-4 font-medium" data-id="element-2721">RATING</th>
                <th className="text-center p-4 font-medium" data-id="element-2722">STATUS</th>
              </tr>
            </thead>
            <tbody data-id="element-2723">
              {HISTORY_DATA.map((row, i) => <Fragment key={i} data-id="element-2724">
                  <tr className={`border-b border-white/5 hover:bg-white/5 ${row.expanded ? 'bg-white/5' : ''}`} data-id="element-2725">
                    <td className="p-4 text-center cursor-pointer" data-id="element-2726">
                      {row.expanded ? <ChevronDown size={16} data-id="element-2727" /> : <ChevronRight size={16} data-id="element-2728" />}
                    </td>
                    <td className="p-4 font-bold" data-id="element-2729">{row.id}</td>
                    <td className="p-4 text-text-secondary" data-id="element-2730">{row.time}</td>
                    <td className="p-4" data-id="element-2731">{row.location}</td>
                    <td className="p-4" data-id="element-2732">
                      <span className={`px-2 py-0.5 rounded text-xs font-bold ${row.channel === 'Wolt' ? 'bg-blue-400/10 text-blue-400' : 'bg-green-400/10 text-green-400'}`} data-id="element-2733">
                        {row.channel}
                      </span>
                    </td>
                    <td className="p-4 text-center" data-id="element-2734">{row.items}</td>
                    <td className="p-4 text-right font-mono" data-id="element-2735">{row.total}</td>
                    <td className="p-4 text-center flex items-center justify-center gap-1" data-id="element-2736">
                      {row.prep}
                      {row.warning && <span className="text-accent-warning" data-id="element-2737">⚠️</span>}
                    </td>
                    <td className="p-4 text-center" data-id="element-2738">
                      <div className="flex items-center justify-center gap-1 text-accent-success font-bold" data-id="element-2739">
                        <Star size={12} fill="currentColor" data-id="element-2740" /> {row.rating}
                      </div>
                    </td>
                    <td className="p-4 text-center" data-id="element-2741">
                      <div className="flex items-center justify-center gap-1 text-accent-success text-xs font-bold uppercase" data-id="element-2742">
                        <Check size={12} data-id="element-2743" /> {row.status}
                      </div>
                    </td>
                  </tr>
                  {row.expanded && row.details && <tr className="bg-background-elevated/30" data-id="element-2744">
                      <td colSpan={10} className="p-4" data-id="element-2745">
                        <div className="bg-background-card rounded-lg border border-white/5 p-6 ml-8 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2746">
                          <div className="space-y-4" data-id="element-2747">
                            <div data-id="element-2748">
                              <div className="text-xs text-text-secondary uppercase font-bold mb-2" data-id="element-2749">
                                Items
                              </div>
                              <div className="space-y-2" data-id="element-2750">
                                {row.details.items.map((item, idx) => <div key={idx} className="flex justify-between text-sm" data-id="element-2751">
                                    <span data-id="element-2752">{item.name}</span>
                                    <span className="text-text-secondary" data-id="element-2753">
                                      {item.price}
                                    </span>
                                  </div>)}
                              </div>
                            </div>

                            <div className="pt-4 border-t border-white/5" data-id="element-2754">
                              <div className="flex justify-between text-sm mb-2" data-id="element-2755">
                                <span className="text-text-secondary" data-id="element-2756">
                                  Stations:
                                </span>
                                <span data-id="element-2757">{row.details.stations}</span>
                              </div>
                              <div className="flex justify-between text-sm" data-id="element-2758">
                                <span className="text-text-secondary" data-id="element-2759">
                                  AI Estimate:
                                </span>
                                <span data-id="element-2760">
                                  {row.details.est} → Actual:{' '}
                                  <span className="font-bold text-accent-warning" data-id="element-2761">
                                    {row.details.actual} ({row.details.diff})
                                  </span>
                                </span>
                              </div>
                            </div>

                            {row.details.comment && <div className="p-3 bg-accent-error/10 rounded text-sm text-accent-error flex gap-2" data-id="element-2762">
                                <MessageSquare size={16} className="shrink-0 mt-0.5" data-id="element-2763" />
                                Customer: "{row.details.comment}"
                              </div>}
                          </div>

                          <div data-id="element-2764">
                            <div className="text-xs text-text-secondary uppercase font-bold mb-2" data-id="element-2765">
                              Timeline
                            </div>
                            <div className="space-y-4 relative pl-4 border-l border-white/10" data-id="element-2766">
                              {row.details.timeline.map((event, idx) => <div key={idx} className="relative" data-id="element-2767">
                                  <div className="absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full bg-background border-2 border-text-secondary" data-id="element-2768"></div>
                                  <div className="flex justify-between text-sm" data-id="element-2769">
                                    <span className="text-text-secondary font-mono" data-id="element-2770">
                                      {event.time}
                                    </span>
                                    <span className="font-medium" data-id="element-2771">
                                      {event.status}
                                    </span>
                                  </div>
                                </div>)}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>}
                </Fragment>)}
            </tbody>
          </table>
        </div>
        <div className="p-4 border-t border-white/5 flex justify-between items-center text-sm text-text-secondary" data-id="element-2772">
          <span data-id="element-2773">Showing 1-50 of 127 orders</span>
          <div className="flex gap-2" data-id="element-2774">
            <button className="px-3 py-1 bg-white/5 rounded hover:bg-white/10" data-id="element-2775">
              ◀ Prev
            </button>
            <button className="px-3 py-1 bg-white/5 rounded hover:bg-white/10" data-id="element-2776">
              Next ▶
            </button>
          </div>
        </div>
      </Card>
    </div>;
}